import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MuiDataTableButton from '@components/DataTable/MuiDataTable/TableButton';
import { Tag } from '@components/Tag';

import type { RowData } from './types';

const messages = defineMessages({
  notStarted: {
    id: 'assessment.notStarted',
    defaultMessage: 'Not Started',
  },
  startAssessment: {
    id: 'assessment.startAssessment',
    defaultMessage: 'Start Assessment',
  },
  viewAssessment: {
    id: 'assessment.viewAssessment',
    defaultMessage: 'View Latest Assessment',
  },
  questionnaire: {
    id: 'assessment.questionnaire',
    defaultMessage: 'Questionnaire',
  },
});

interface PatientMobileRowProps {
  data: RowData;
  dataIndex: number;
  onRowClick: () => void;
  onStartAssessment: () => void;
  onStartQuestionnaire: () => void;
}
export default function PatientMobileRow({
  data,
  dataIndex,
  onRowClick,
  onStartAssessment,
  onStartQuestionnaire,
}: PatientMobileRowProps) {
  const { formatMessage } = useIntl();
  // Order of table columns
  const { name, dob, assessmentDate } = data;
  const isComplete = Boolean(assessmentDate);

  return (
    <tr style={{ height: 'auto' }} onClick={onRowClick}>
      <td style={{ paddingTop: dataIndex === 0 ? 20 : 10, paddingBottom: 5 }}>
        <Stack sx={{ px: 2 }} spacing={1}>
          <Stack direction="row" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography>{name}</Typography>
              <Typography
                color="text.secondary"
                variant="caption"
              >{`DOB: ${dob}`}</Typography>
            </Stack>
            <Tag
              color={isComplete ? 'success.main' : 'error.main'}
              label={
                isComplete && assessmentDate
                  ? assessmentDate
                  : formatMessage(messages.notStarted)
              }
              variant="secondary"
            />
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <MuiDataTableButton
              // Disable button after BHA completion
              disabled={data.vitall_patient.disabled}
              onClick={onStartAssessment}
              text={formatMessage(messages.startAssessment)}
            />
            {isComplete && (
              <MuiDataTableButton
                text={formatMessage(messages.viewAssessment)}
              />
            )}
            <MuiDataTableButton
              onClick={onStartQuestionnaire}
              text={formatMessage(messages.questionnaire)}
            />
          </Stack>
        </Stack>
        <Divider />
      </td>
    </tr>
  );
}
